import {AxiosPromise} from 'axios';

import {instanceGusaBackend} from 'libs/api';
import {API_URL} from 'constants/api';
import {APP} from 'constants/actions';
import {ENDPOINTS} from 'constants/endpoints';
import {ActionType} from '@typescript/common/actionTypes';
import {PageAppType} from 'reducers/app/pageApp/pageAppType';

/**
 * Get router info data
 * @param {string} url Current url
 * @returns {ActionType<AxiosPromise>} action
 */
export function getRouterInfo(url: string): ActionType<AxiosPromise> {
    return {
        type: APP.GET_ROUTER_INFO,
        payload: instanceGusaBackend({
            method: 'get',
            baseURL: API_URL,
            url: ENDPOINTS.ROUTE_GET_INFO_BY_PATHNAME({url}),
        }),
    };
}

/**
 * Save current page to store
 * @param {PageAppType} page Current page data
 * @returns {ActionType<PageAppType>} action
 */
export function saveAppPage(page: PageAppType): ActionType<PageAppType> {
    return {
        type: APP.SAVE_LOCATION,
        payload: page,
    };
}
